import { CarvanaTheme } from '@carvana/showroom-theme';
import styled from 'styled-components';
import Button from '~/styles/Button/BlueButton';
import ButtonBase from '~/styles/Button/ButtonBase';

export const Title = styled.div`
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
  margin: 0 0 15px;
  padding: 0 19px;
  line-height: 1.2;

  @media (min-width: ${CarvanaTheme.breakpoint.md}px) {
    margin: 0 0 14px;
    font-size: 28px;
    line-height: 1.5;
  }
`;

export const SubTitle = styled.div`
  text-align: center;
  color: ${CarvanaTheme.color.neutral.v500};
  margin: 0 0 30px;
  font-size: 16px;
  padding: 0 1px;

  @media (min-width: ${CarvanaTheme.breakpoint.md}px) {
    font-size: 21px;
    padding: 0 35px;
  }
`;

export const NotifyButton = styled(Button)`
  display: flex;
  width: 100%;
  max-width: 307px;
  border-radius: 3px;
`;

export const GreatDealButton = styled(ButtonBase)`
  display: flex;
  width: 100%;
  max-width: 307px;
  border-radius: 3px;
  border: ${props => `2px solid ${props.theme.carvana.blue.primary}`};
  height: 56px;
  color: ${props => props.theme.carvana.blue.primary};
  transition: border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &:hover {
    border: ${props => `2px solid ${props.theme.carvana.blue.hover}`};
    color: ${props => props.theme.carvana.blue.hover};
  }
`;

export const CtaWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-flow: column;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: center;

  ${GreatDealButton} {
    margin: 10px 0 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    flex-flow: row;
    ${GreatDealButton} {
      margin: 0 0 0 10px;
    }
  }
`;

export const NoResultsWrapper = styled.div.attrs({
  'data-qa': 'no-results-wrapper'
})`
  text-align: center;
  margin: 40px 0;
  padding: 0 12px;
  width: 100%;

  @media (min-width: ${CarvanaTheme.breakpoint.md}px) {
    margin: 50px 0;
    padding: 0 32px;
  }
`;
